
function Layout() {
    this.footer = document.querySelector('.footer');
    this.header = document.querySelector('.header');
    this.content = document.querySelector('.wrapper');
    this.header_height;
    this.footer_height;

    var that = this;

    jQuery(document).ready(function () {
        that.init();
    });
}

Layout.prototype.init = function () {
    this.setHeaderClearHeight();
    this.initHeaderScrollListener();
};

Layout.prototype.setFooterClearHeight = function () {
    this.footer_height = this.footer.getBoundingClientRect().height;
    this.wrapper.style.marginBottom = this.footer_height + 'px';
};

Layout.prototype.setHeaderClearHeight = function () {
    this.header_height = this.header.getBoundingClientRect().height;
};

Layout.prototype.initHeaderScrollListener = function () {
    var that = this,
        doc = document.documentElement,
        lastScroll = 0;

    window.addEventListener(
        'scroll',
        function (e) {
            var top = (window.pageYOffset || doc.scrollTop) - (doc.clientTop || 0);

            if (top > that.header_height / 2 && that.header.classList.contains('float')) {
                if (top < lastScroll) {
                    that.header.classList.add('show');
                    top++; // Fix for ie - trick that fixes showing/hiding on every scroll
                } else {
                    that.header.classList.remove('show');
                }
            }

            lastScroll = top;
        },
        false
    );
};

export default Layout;


// WEBPACK FOOTER //
// ./js/components/layout/index.js